// Initialize Fancybox for product images and panels
(function() {
    'use strict';

    let initAttempts = 0;
    const maxAttempts = 50; // 5 segundos máximo

    function initFancybox() {
        initAttempts++;

        // Check if Fancybox is available (could be window.Fancybox or just Fancybox)
        const FancyboxLib = window.Fancybox || (typeof Fancybox !== 'undefined' ? Fancybox : null);

        if (!FancyboxLib) {
            if (initAttempts >= maxAttempts) {
                console.warn('Fancybox not loaded after multiple attempts');
                return;
            }
            // Wait a bit and try again if Fancybox is not loaded yet
            setTimeout(initFancybox, 100);
            return;
        }

        // Initialize Fancybox for product images
        const isMobile = window.innerWidth < 768;

        // Store original body overflow to restore later
        let originalBodyOverflow = '';

        FancyboxLib.bind('[data-fancybox="images"]', {
            Image: {
                zoom: !isMobile, // Disable zoom on mobile
                wheel: isMobile ? false : 'slide'
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close']
                }
            },
            Thumbs: {
                showOnStart: !isMobile, // Hide thumbs on mobile
                autoStart: !isMobile
            },
            Carousel: {
                infinite: true
            },
            on: {
                reveal: (fancybox, slide) => {
                    // Store original overflow before Fancybox modifies it
                    const body = document.body;
                    if (!originalBodyOverflow) {
                        originalBodyOverflow = body.style.overflow || getComputedStyle(body).overflow || '';
                    }

                    // Ensure proper rendering on mobile
                    if (isMobile) {
                        setTimeout(() => {
                            fancybox.update();
                            if (slide.content) {
                                slide.content.style.transform = '';
                                requestAnimationFrame(() => {
                                    fancybox.update();
                                });
                            }
                        }, 50);
                    }
                },
                close: (fancybox) => {
                    // Restore original body overflow when Fancybox closes
                    const body = document.body;
                    if (originalBodyOverflow !== '') {
                        body.style.overflow = originalBodyOverflow;
                        originalBodyOverflow = '';
                    } else {
                        // If no original value was stored, remove the style attribute
                        body.style.overflow = '';
                    }
                },
                destroy: (fancybox) => {
                    // Ensure overflow is restored on destroy as well
                    const body = document.body;
                    if (originalBodyOverflow !== '') {
                        body.style.overflow = originalBodyOverflow;
                        originalBodyOverflow = '';
                    } else {
                        body.style.overflow = '';
                    }
                }
            }
        });

        // Initialize Fancybox for panels (if any)
        FancyboxLib.bind('[data-fancybox="panel"]', {
            type: 'clone'
        });

        // Initialize Fancybox for video gallery
        FancyboxLib.bind('[data-fancybox="video-gallery"]', {
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close']
                }
            }
        });

        // General Fancybox bind for any other triggers (like FAQ)
        FancyboxLib.bind('[data-fancybox]', {
            type: 'inline',
            autoFocus: false,
            trapFocus: false,
            placeFocusBack: false,
            on: {
                reveal: (fancybox, slide) => {
                    const body = document.body;
                    if (!originalBodyOverflow) {
                        originalBodyOverflow = body.style.overflow || getComputedStyle(body).overflow || '';
                    }
                },
                close: (fancybox) => {
                    const body = document.body;
                    if (originalBodyOverflow !== '') {
                        body.style.overflow = originalBodyOverflow;
                        originalBodyOverflow = '';
                    } else {
                        body.style.overflow = '';
                    }
                }
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFancybox);
    } else {
        initFancybox();
    }

    // Also try after a delay to ensure Fancybox is loaded
    setTimeout(initFancybox, 500);
})();


















